<template>
  <el-dialog :close-on-click-modal="false" append-to-body :title="isEdit ? '编辑产品类' : '添加产品类'" :visible.sync="isShow" width="500px" @closed="cancel">
    <el-form ref="categoryVo" :model="categoryVo" :rules="rules" label-width="100px" @closed="cancel">
      <el-form-item label="产品类:" prop="categoryName">
        <el-input v-model="categoryVo.categoryName"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel()">取 消</el-button>
      <el-button type="primary" @click="confirm()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { posCategoryAdd, posCategoryUpdate } from '@/api/pms.js'
export default {
  props: ['tagsId'],
  data () {
    return {
      rules: {
        categoryName: [
          { required: true, message: '请输入产品类名称', trigger: 'blur' }
        ]
      },
      isShow: false,
      isEdit: false,
      categoryVo: {
        categoryName: '',
        level: 0,
        parentId: 0,
        tagsId: this.tagsId
      }
    }
  },
  methods: {
    show (scope, isEdit) {
      this.isShow = true
      this.isEdit = isEdit
      this.init(scope, isEdit)
    },
    hide () {
      this.$emit('success')
      this.$emit('fatherMethod')
      this.isShow = false
    },
    init (scope, isEdit) {
      console.log(scope.row)
      if (isEdit) {
        this.categoryVo = scope.row
      } else {
        if (scope === 'top') {
          this.categoryVo.parentId = 0
          this.categoryVo.level = 1
        } else {
          this.categoryVo.parentId = scope.row.categoryId
          this.categoryVo.level = scope.row.level + 1
        }
      }
    },
    cancel () {
      this.isShow = false
      this.$refs.categoryVo.resetFields()
    },
    confirm () {
      this.$refs.categoryVo.validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            posCategoryUpdate({
              categoryId: this.categoryVo.categoryId,
              data: this.categoryVo
            })
              .then(res => {
                this.$message.success('编辑成功')
                this.$refs.categoryVo.resetFields()
                this.hide()
              })
          } else {
            posCategoryAdd(this.categoryVo)
              .then(res => {
                if (res.data.success) {
                  this.$message.success('添加成功')
                  this.$refs.categoryVo.resetFields()
                  this.hide()
                  // this.$parent.initDate()
                }
              })
          }
        }
      })
    }
  }
}
</script>

<style>
</style>
